import { isProductionClient } from '@/utils/helpers';

function getScreenParams() {
  if (typeof window.screen === 'undefined') return '';

  const colorDepth = window.screen.colorDepth || window.screen.pixelDepth;

  return `;s${window.screen.width}*${window.screen.height}*${colorDepth}`;
}

export function trackLiveInternetHit() {
  const { isProductionHref } = isProductionClient();

  if (!isProductionHref) return;

  const referrer = encodeURIComponent(document.referrer);
  const url = encodeURIComponent(document.URL);

  new Image().src = `//counter.yadro.ru/hit?r${referrer}${getScreenParams()};u${url};${Math.random()}`;
}
